<template>
<div>
<div class="footer-index">
<ul class="footer-list">
	<li class="li-contact">
		<p class="footer-liner"></p>
		<h3 class="footer-title">联系我们</h3>
		<p>总部：北京丰台恒泰中心D16</p>
		<p>联系电话：63896055-8019</p>
		<p>商务电话：13699291824</p>
	</li>
	<li class="li-contact">
		<p class="footer-liner"></p>
		<h3 class="footer-title">产品服务</h3>
		<p>
			<a href="javascript:void(0)">产品介绍</a>
			<router-link tag="a" :to="{path: '/assetsPricing'}">资产定价</router-link>
		</p>
		<p>
			<a href="javascript:void(0)">坏账揽收</a>
			<a href="javascript:void(0)">资金供给</a>
		</p>
		<p>
			<router-link tag="a" :to="{path: '/antiFraud'}">反欺诈</router-link>
		</p>
	</li>
	<li class="li-contact">
		<p class="footer-liner"></p>
		<h3 class="footer-title">关于我们</h3>
		<p>
			<router-link tag="a" :to="{path: '/aboutUs'}">关于我们</router-link>
		</p>
		<p>
			<router-link tag="a" :to="{path: '/joinUs'}">加入我们</router-link>
		</p>
		<p>
			<a href="javascript:void(0)">联系我们</a>
		</p>
	</li>
	<li class="li-linear"></li>
	<li>
		<div class="QR_code-box l">
			<p>APP下载</p>
			<div><img src="../homepageComponent/images/QR_code2.png"></div>
		</div>
		<div class="QR_code-box l">
			<p>官方微信</p>
			<div><img src="../homepageComponent/images/QR_code.png"></div>
		</div>
	</li>
	<p class="footer-index2-text">沈阳金融商贸开发区森强小额贷款有限公司 版权所有 ©2018-2024 <a target='_blank' href="https://beian.miit.gov.cn/#/Integrated/index">辽ICP备19003580号-1</a></p>
</ul>
</div>
<div class="footer-index2">
	
</div>
</div>
</template>

<script type="text/ecmascript-6">
	export default{
		data(){
			return{}
		},
	}
</script>
<style>
	@import '../../css/footer-index.css'
</style>



// WEBPACK FOOTER //
// src/components/common/footerIndex.vue